module.exports = __webpack_public_path__ + "img/insta.200a08fd.png";